/** @jsx jsx */
import {jsx} from '@emotion/react'
import Success4624 from '../components/templates/sp-4624/success/success-4624'

const SuccessPage = ({languageCode = 'en'}) => {
    return <Success4624 languageCode={languageCode} />
}

export default SuccessPage
